import { Pipe, PipeTransform } from '@angular/core';

import { get } from 'lodash';

import { Vehicle } from '@commons/models/domain/Vehicle';
import { MappingService } from '@commons/services/mapping/mapping.service';
import { IOnChangedTachoFilters } from '@src/app/interfaces/filters-vehicle.interface';
import { TachoStatusWorker } from '@commons/enums/tacho.enum';

@Pipe({
  name: 'filterTachoList'
})
export class FilterTachoListPipe implements PipeTransform {

  private checkStatusItem(item: Vehicle, selectedStatus: number): boolean {
    const tachoStatus = this.getTachoStatus(item);
    const tachoDriverID = this.getDriverId(item);

    if (tachoStatus !== null && tachoDriverID) {
      const status = MappingService.convertTachoStatus(tachoStatus);
      return selectedStatus === null || (status === selectedStatus);
    }
    return false;
  }

  private getTachoStatus = (item: Vehicle) => {
    return get(item, 'Tacho.S1.St', get(item, 'Tacho.S2.St', null));
  }

  private getDriverId = (item: Vehicle) => {
    return get(item, 'Tacho.S1.Id', get(item, 'Tacho.S2.Id', null));
  }
  
  transform(list?: Vehicle[], filters?: IOnChangedTachoFilters): Vehicle[] | undefined {
    if (list) {
      const { selectedStatus } = filters || {};

      if (selectedStatus || selectedStatus === 0) {
        const filterFnc = (item: Vehicle): boolean => {
          const hasStatus = this.checkStatusItem(item, selectedStatus);
          return hasStatus;
        };

        const ifUnkownStatusSelected = filters?.selectedStatus === TachoStatusWorker.Unkown;

        if (ifUnkownStatusSelected) {
          return list.filter(item => {
            const status = this.getTachoStatus(item);
            return status === null || !this.getDriverId(item);
          });
        }
        return list.filter((item) => item.Tacho && filterFnc(item));
      }
    }
    return list;
  }

}
